import React, { Component } from 'react';
class NoCaseWorkersSplashPage extends Component {
    render() {
        return (
            <main className='splash-page-container'>
                <img className='sent-request-img' alt='appointment sent' src='/appointment-sent.png'/>
                <div className='splash-page-text'>
                  <p>This feature has not been set up by the organization.</p>
                </div>
                <div>
                  <button onClick={e => window.location.href='/appointments'} className='ssg-forms-btn ssg-forms-btn-secondary'>View Appointments</button>
                  <button onClick={e => window.location.href='/'} className='ssg-forms-btn ssg-forms-btn-primary'>Go to Dashboard</button>
                </div>
            </main>
        )
    }
}

export default NoCaseWorkersSplashPage;


// WEBPACK FOOTER //
// src/dashboard/appointments/no-case-workers-splash-page.component.js